import { Profil, Societe } from "@/shared/Groupe";

export class UserComplement {
  public cle: string = "";
  public typeValue: string = "STRING";
  public valeur: string = "";
}

export class User {
  public login: string = "";
  public id: string = "";
  public droits: string[] = [];
  public currency: string = "";
  public password: string = "";
  public token: string = "";
  public profile: Profil = new Profil();
  public raisonsSociales: string[] = [];
  public restaurantIds: number[] = [];
  public societesPlus: Societe[] = [];
  public societesMoins: Societe[] = [];
  public newPassword?: string = "";
  public email: string = "";
  public rePasswordKey?: string = "";
  public activationKey?: string = "";
  public theme: string = "";
  public couleur: string = "";
  public caisse?: boolean = false;
  public codeExploitant?: string = "";
  public complements?: UserComplement[] = [];
  public role?: string = "";
  public country: string = "";
  public language: string = "";
  public variant: string = "";

  public $edit?: boolean = false;

  public init(
    login: string,
    id: string,
    droits: string,
    currency: string,
    token: string,
    role?: string
  ) {
    this.login = login;
    this.id = id;
    this.droits = JSON.parse(droits);
    this.currency = currency;
    this.token = token;
    if (role) {
      this.role = JSON.parse(role);
    }
  }
}
